import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpMethod } from '../../../core/enums/http-handlers';
import { AppUrl, SubcriptionReminder, URLS } from '../../../core/enums/urls';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { SessionService } from 'src/app/core/services/session.service';
import { AlertService } from 'src/app/core/services/alert.service';

@Component({
  standalone: false,
  selector: 'app-buyapp',
  templateUrl: './buyapp.component.html',
  styleUrls: ['./buyapp.component.scss'],
  providers: [
    DatePipe
  ]
})
export class BuyappComponent implements OnInit {
  @Output() emitProcess = new EventEmitter();
  @Input() appData: any = null;
  @Input() currentUser: any;
  @Input() redirectTo: any = 'apps'
  appAcmId = 0
  priceType: string = '';
  subUserId: any;
  params: HttpParams = new HttpParams();
  subPrice: any;
  modalReference: any;
  closeResult: string = '';
  termAndConditions: boolean = false;
  name: string = '';
  status: string = '';
  fromDate: string = '';
  toDate: string = '';
  orderby: string = '';
  pagesize: any = 15;
  pageindex: any = 1;
  subscriptionData: any = [];
  subscriptionDataCount: any = 0;
  todaydate: Date = new Date();
  priceId: any;
  aiwalletData: any;
  walletAmount: number = 0;
  remainingBalance: number = 0;
  paymentMthodsData: any = [];


  constructor(
    public sessionService: SessionService,
    //public appService: AppService,
    private alertService: AlertService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private router: Router,
    private datepipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.getAppDetails();
    this.checkPaymentMethods();
    // this.getWalletDetails();
    // this.subPrice = this.InstalledAppsData.find(res => res.acM_Id === appAcmId);
  }
  checkPaymentMethods() {
    this.sessionService.commonApiCall(
      SubcriptionReminder.StripePaymentMethods,
      HttpMethod.GET,
      null,
      (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.paymentMthodsData = res.listResult;
        }
        this.sessionService.hide();
      }
    );
  }
  getAppDetails() {
    debugger
    // this.sessionService.show();
    this.params = new HttpParams()
      .set("user_Id", this.appData?.user_Id ? this.appData?.user_Id : '');
    const url = AppUrl.appByACMId
    this.sessionService.commonApiCall(
      url + '/' + this.appData?.acM_Id + '?' + this.params,
      HttpMethod.GET,
      null, (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.subPrice = res;
          if (this.subPrice?.monthlyPrice && this.subPrice?.monthlyPrice > 0) {
            this.selectPrice('monthly');
          }
          if (this.subPrice?.yearlyPrice && this.subPrice?.yearlyPrice > 0) {
            this.selectPrice('yearly');
          }
          else if (this.subPrice?.trialEnded == false && this.subPrice?.trialDays > 0) {
            this.selectPrice('trial');
          }
        }
        this.sessionService.hide();
      }
    );
  }

  selectPrice(value: any) {
    this.priceType = value;
    if (value == 'yearly') {
      this.priceId = this.subPrice?.yearlyPriceId;
      const selectedYearlyPrice = this.subPrice?.yearlyAfterDiscPrice || 0;
      this.remainingBalance = this.walletAmount - selectedYearlyPrice;
    }
    else if (value == 'monthly') {
      this.priceId = this.subPrice?.monthlyPriceId;
      const selectedMonthlyPrice = this.subPrice?.monthlyAfterDiscPrice || 0;
      this.remainingBalance = this.walletAmount - selectedMonthlyPrice;
    }
  }

  openXl(content: any) {
    this.modalReference = this.modalService.open(content, {
      windowClass: "modal-holder",
      size: "md",
    });
    this.modalReference.result.then(
      (result: any) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason2(reason)}`;
      }
    );
  }

  private getDismissReason2(reason: any): string {
    this.priceType = "";
    this.termAndConditions = false;
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  stripePayment() {
    const obj = {
      price_Id: this.priceId,
      mode: 'subscription',
      qty: 1,
      amount: 1,
      createdDate: this.datepipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss')
    };
    const url = SubcriptionReminder.RechargeWallet;
    this.sessionService.commonApiCall(
      url,
      HttpMethod.POST,
      obj,
      (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          window.open(res.url, '_blank');
        }
        this.sessionService.hide();
      }
    );
  }

  installApp() {
    // if (this.remainingBalance < 0 && (this.priceType == 'yearly' || this.priceType == 'monthly')) {
    //   this.alertService.showMessage(
    //     AlertInfo.ERROR,
    //     'Insufficient balance in your wallet. Please recharge your wallet to continue.',
    //   );
    //   return;
    // }
    const url = AppUrl.APP_SubscriptionFromCard;
    const obj = {
      acM_Id: this.appData?.acM_Id,
      user_Id: this.appData?.user_Id,
      priceType: this.priceType,
      createdDate: this.datepipe.transform(new Date(), 'yyyy-MM-ddTHH:mm:ss')
    };
    this.sessionService.commonApiCall(
      url,
      HttpMethod.POST,
      obj, (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.activeModal.close('Cross click');
          this.getMyApps();
          //this.sessionService.getCheckoutApps();
          // if (this.currentUser?.paymentCard == false) {
          //   const url = RedirectRoutes.APPS + '/' + 'checkout';
          // if (this.redirectTo == 'appsubscriptions')
          this.router.navigate([decodeURIComponent('app/learn/subscriptions/list')]);
          // else if (this.redirectTo == 'apps')
          //   this.router.navigate([decodeURIComponent('apps/myapps')]);
          // else if (this.redirectTo == 'staff')
          //   this.router.navigate([decodeURIComponent('staff')]);
          // else
          //   this.router.navigate([decodeURIComponent('apps/myapps')]);
          // }
        }
        this.sessionService.hide();;
        this.termAndConditions = false;
      }
    );
  }

  getMyApps() {
    this.sessionService.commonApiCall(
      AppUrl.myApps,
      HttpMethod.GET,
      null,
      (result: any, statusFlag: boolean) => {
        if (statusFlag) {
          //this.appService.setMenu(result.listResult);
          result.listResult.forEach((a: any) => {
            //this.appService.myAppsList?.push(a);
            //this.appService.checkSubscriptionTime(a.appCode);
            //a.status = this.appService.trailInfo;
          });
        }
      });
  }

  getWalletDetails() {
    const url = URLS.AiWallet;
    this.sessionService.commonApiCall(
      url,
      HttpMethod.GET,
      null,
      (res: any, statusFlag: boolean) => {
        if (statusFlag) {
          this.aiwalletData = res;
          this.walletAmount = res.walletAmount;
          this.walletAmount = Math.floor(this.aiwalletData?.amount * 100) / 100;
          this.getAppDetails();
        }
        this.sessionService.hide();
      }
    );
  }
}
